// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
  position: relative;
  z-index: 2;
  max-height: 5.5rem;
  background-color: #fcfbf9;
}

header.full-width {
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  margin: 0;
  max-width: unset;
}

header.primary {
  background: #f8f3ed;
}
header.secondary {
  background: #aa4e4d;
}

.header__logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header__logo img {
  display: block;
  width: 100%;
  max-width: 3rem;
}

.header__logo span {
  /* font-size: 1.688rem; */
  font-size: 1rem;
  margin-left: 0.5rem;
  text-transform: uppercase;
  color: var(--clr-primary);
}

nav {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 1.5rem;
}

.header__items {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  clip-path: circle(5px at 86% -1%);
  -webkit-clip-path-: circle(50px at 86% 0%);
  -moz-clip-path-: circle(50px at 86% 0%);
  width: 100vw;
  padding: 2em 0;
  z-index: 2000;
  background: var(--clr-primary);
  transition: all 0.5s ease-in-out;
  overflow-x: hidden;
  color: var(--clr-light);
}

nav .cross-mark {
  right: 6%;
  display: none;
  position: absolute;
  top: 1.5rem;
}
nav .cross-mark::after,
nav .cross-mark::before {
  background: var(--clr-light);
}

.header__checked {
  position: absolute;
  width: 2rem;
  z-index: 1002;
  height: 2rem;
  opacity: 0;
  right: -0.25rem;
  top: 1.5rem;
}

.header__checked:checked ~ ul {
  clip-path: circle(900px at 86% 20%);
  -webkit-clip-path-: circle(900px at 86% 20%);
  -moz-clip-path-: circle(900px at 86% 20%);
}

.header__checked:checked ~ .cross-mark {
  display: block;
  position: fixed;
  z-index: 10000;
  right: 8%;
  top: 2rem;
}

.header__checked:checked {
  position: fixed;
}

.header__item {
  /* font-size: 1.5rem; */
  /* display: none; */
  cursor: pointer;
  margin: 1rem;
  /* font-size: 1.25rem; */
}

.header__profile {
  margin: 0;
  margin-right: -1rem;
}

.header__menu svg,
.header__profile svg {
  width: 1rem;
}

.header__menu,
.header__profile {
  display: flex;
}
.header__profile.active svg path {
  stroke: var(--clr-primary);
}

.header__item a {
  color: var(--clr-light);
  font-weight: 600;
}

.header__menuDropdownContainer {
  position: relative;
  width: 100%;
}

.header__menuDropdownItems {
  position: absolute;
  right: 50%;
  transform: translateX(25%);
  top: calc(100% + 0.75rem);
  width: calc(100% + 12rem);
  border-radius: 1em;
  background: var(--clr-secondary);
  box-shadow: 0 0.25rem 1rem #0002;
  padding: 0.25em 0;
}

.header__menuDropdownItems li,
.header__menuDropdownItems li > div {
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
}

.header__menuDropdownItems li {
  color: var(--clr-gray600);
  transition: 0.25s;
  font-weight: 600;
  cursor: pointer;
}

.header__menuDropdownItems li > div span {
  margin-left: 1rem;
  font-size: 0.8rem;
}

.header__menuDropdownItems li.quizz > div span {
  margin: 0;
}

.header__menuDropdownItems li > div {
  display: flex;
  align-items: center;
}

.header__menuDropdownItems li svg {
  width: 1.25rem;
  fill: transparent;
}

.header__menuDropdownItems li.quizz svg {
  width: 1.65rem;
  margin-left: -0.15rem;
}

.header__menuDropdownItems li:hover svg rect,
.header__menuDropdownItems li:hover svg path,
.header__menuDropdownItems li svg rect,
.header__menuDropdownItems li svg path {
  stroke: var(--clr-gray600) !important;
}

/* .header__menuDropdownItems li:hover, */
.header__menuDropdownItems li:hover,
.header__menuDropdownItems li:hover,
.header__menuDropdownItems li.active {
  color: var(--clr-primary) !important;
}

/* .header__menuDropdownItems li:hover svg rect, */
/* .header__menuDropdownItems li:hover svg path, */
.header__menuDropdownItems li:hover svg rect,
.header__menuDropdownItems li:hover svg path,
.header__menuDropdownItems li.active svg rect,
.header__menuDropdownItems li.active svg path {
  stroke: var(--clr-primary) !important;
}

.header__menuDropdownItems li:first-of-type.active svg rect,
.header__menuDropdownItems li:first-of-type.active svg path,
.header__menuDropdownItems li:first-of-type:hover svg rect,
.header__menuDropdownItems li:first-of-type:hover svg path {
  fill: var(--clr-primary) !important;
}

/* .header__menuDropdownItems li:first-of-type.active svg rect,
.header__menuDropdownItems li:last-of-type.active svg rect,
.header__menuDropdownItems li:first-of-type.active svg path,
.header__menuDropdownItems li:last-of-type.active svg path,
.header__menuDropdownItems li:first-of-type:hover svg rect,
.header__menuDropdownItems li:last-of-type:hover svg rect,
.header__menuDropdownItems li:first-of-type:hover svg path,
.header__menuDropdownItems li:last-of-type:hover svg path {
} */

.header__menuDropdownItemAuth {
  font-weight: bold;
  font-size: 0.8rem;
  padding: 0.5em 1em;
  width: 100%;
  display: block;
  color: var(--clr-gray600) !important;
  text-align: right;
}

.header__menuDropdownItemAuth.logout {
  color: var(--clr-primary) !important;
}

.header__menu.text-white .header__mobileIcon path {
  fill: var(--clr-light);
}

.header__menu.text-white svg path,
.header__profile.text-white svg path {
  stroke: var(--clr-light);
}

@media (min-width: 768px) {
  .header__logo span {
    font-size: 1.25rem;
  }
}

@media (min-width: 992px) {
  header {
    max-height: 7.5rem;
  }

  .header__items {
    flex-direction: row;
    position: unset;
    clip-path: none;
    height: 100%;
    width: 100%;
    /* gap: 1rem; */
    background: transparent;
    -webkit-clip-path-: none;
    -moz-clip-path-: none;
    color: var(--clr-dark);
  }

  .header__checked {
    display: none;
  }

  .header__item {
    font-size: 0.75rem;
    display: flex;
    margin: 0 0.5rem;
  }

  .header__item.active,
  .header__item.active a {
    color: var(--clr-primary);
  }
  .header__mobileIcon {
    display: none;
  }

  .header__logo img {
    max-width: 3.5rem;
  }

  .header__logo span {
    display: inline-block;
    white-space: nowrap;
  }

  .header__item.text-white {
    color: var(--clr-light);
  }

  .header__item.text-white a,
  .header__item a {
    color: var(--clr-light);
  }

  .header__menu.text-white svg path,
  .header__profile.text-white svg path {
    stroke: var(--clr-light);
  }

  .header__item a {
    color: var(--clr-dark);
  }

  .header__item.active,
  .header__item.active a {
    color: var(--clr-primary);
  }
}

/* @media (min-width: 992px) {
  .header__logo span {
    display: inline-block;
    white-space: nowrap;
  }
} */

@media (min-width: 1100px) {
  .header__items {
    margin-right: -1rem;
  }

  .header__item {
    font-size: 0.85rem;
    margin: 0 0.6rem;
  }
}

@media (min-width: 1300px) {
  .header__logo span {
    display: inline-block;
    white-space: nowrap;
    font-size: 1.5rem;
  }

  /* .header__items {
    gap: 1.5rem;
  } */

  .header__logo img {
    max-width: 4rem;
  }
  .header__item {
    font-size: 1rem;
  }
}

@media (min-width: 1800px) {
  header.full-width {
    padding-left: 20%;
    padding-right: 20%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,iCAAiC;EACjC,0CAA0C;EAC1C,uCAAuC;EACvC,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,SAAS;EACT,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;;;EAGE,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD,kDAAkD;AAClD;;;;EAIE,qCAAqC;AACvC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,yBAAyB;EAC3B;AACF;;AAEA;;;;;GAKG;;AAEH;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1em 0;\n  position: relative;\n  z-index: 2;\n  max-height: 5.5rem;\n  background-color: #fcfbf9;\n}\n\nheader.full-width {\n  width: 100%;\n  padding-left: 10%;\n  padding-right: 10%;\n  margin: 0;\n  max-width: unset;\n}\n\nheader.primary {\n  background: #f8f3ed;\n}\nheader.secondary {\n  background: #aa4e4d;\n}\n\n.header__logo {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.header__logo img {\n  display: block;\n  width: 100%;\n  max-width: 3rem;\n}\n\n.header__logo span {\n  /* font-size: 1.688rem; */\n  font-size: 1rem;\n  margin-left: 0.5rem;\n  text-transform: uppercase;\n  color: var(--clr-primary);\n}\n\nnav {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  gap: 1.5rem;\n}\n\n.header__items {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  clip-path: circle(5px at 86% -1%);\n  -webkit-clip-path-: circle(50px at 86% 0%);\n  -moz-clip-path-: circle(50px at 86% 0%);\n  width: 100vw;\n  padding: 2em 0;\n  z-index: 2000;\n  background: var(--clr-primary);\n  transition: all 0.5s ease-in-out;\n  overflow-x: hidden;\n  color: var(--clr-light);\n}\n\nnav .cross-mark {\n  right: 6%;\n  display: none;\n  position: absolute;\n  top: 1.5rem;\n}\nnav .cross-mark::after,\nnav .cross-mark::before {\n  background: var(--clr-light);\n}\n\n.header__checked {\n  position: absolute;\n  width: 2rem;\n  z-index: 1002;\n  height: 2rem;\n  opacity: 0;\n  right: -0.25rem;\n  top: 1.5rem;\n}\n\n.header__checked:checked ~ ul {\n  clip-path: circle(900px at 86% 20%);\n  -webkit-clip-path-: circle(900px at 86% 20%);\n  -moz-clip-path-: circle(900px at 86% 20%);\n}\n\n.header__checked:checked ~ .cross-mark {\n  display: block;\n  position: fixed;\n  z-index: 10000;\n  right: 8%;\n  top: 2rem;\n}\n\n.header__checked:checked {\n  position: fixed;\n}\n\n.header__item {\n  /* font-size: 1.5rem; */\n  /* display: none; */\n  cursor: pointer;\n  margin: 1rem;\n  /* font-size: 1.25rem; */\n}\n\n.header__profile {\n  margin: 0;\n  margin-right: -1rem;\n}\n\n.header__menu svg,\n.header__profile svg {\n  width: 1rem;\n}\n\n.header__menu,\n.header__profile {\n  display: flex;\n}\n.header__profile.active svg path {\n  stroke: var(--clr-primary);\n}\n\n.header__item a {\n  color: var(--clr-light);\n  font-weight: 600;\n}\n\n.header__menuDropdownContainer {\n  position: relative;\n  width: 100%;\n}\n\n.header__menuDropdownItems {\n  position: absolute;\n  right: 50%;\n  transform: translateX(25%);\n  top: calc(100% + 0.75rem);\n  width: calc(100% + 12rem);\n  border-radius: 1em;\n  background: var(--clr-secondary);\n  box-shadow: 0 0.25rem 1rem #0002;\n  padding: 0.25em 0;\n}\n\n.header__menuDropdownItems li,\n.header__menuDropdownItems li > div {\n  display: flex;\n  align-items: center;\n  padding: 0.5em 1em;\n}\n\n.header__menuDropdownItems li {\n  color: var(--clr-gray600);\n  transition: 0.25s;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.header__menuDropdownItems li > div span {\n  margin-left: 1rem;\n  font-size: 0.8rem;\n}\n\n.header__menuDropdownItems li.quizz > div span {\n  margin: 0;\n}\n\n.header__menuDropdownItems li > div {\n  display: flex;\n  align-items: center;\n}\n\n.header__menuDropdownItems li svg {\n  width: 1.25rem;\n  fill: transparent;\n}\n\n.header__menuDropdownItems li.quizz svg {\n  width: 1.65rem;\n  margin-left: -0.15rem;\n}\n\n.header__menuDropdownItems li:hover svg rect,\n.header__menuDropdownItems li:hover svg path,\n.header__menuDropdownItems li svg rect,\n.header__menuDropdownItems li svg path {\n  stroke: var(--clr-gray600) !important;\n}\n\n/* .header__menuDropdownItems li:hover, */\n.header__menuDropdownItems li:hover,\n.header__menuDropdownItems li:hover,\n.header__menuDropdownItems li.active {\n  color: var(--clr-primary) !important;\n}\n\n/* .header__menuDropdownItems li:hover svg rect, */\n/* .header__menuDropdownItems li:hover svg path, */\n.header__menuDropdownItems li:hover svg rect,\n.header__menuDropdownItems li:hover svg path,\n.header__menuDropdownItems li.active svg rect,\n.header__menuDropdownItems li.active svg path {\n  stroke: var(--clr-primary) !important;\n}\n\n.header__menuDropdownItems li:first-of-type.active svg rect,\n.header__menuDropdownItems li:first-of-type.active svg path,\n.header__menuDropdownItems li:first-of-type:hover svg rect,\n.header__menuDropdownItems li:first-of-type:hover svg path {\n  fill: var(--clr-primary) !important;\n}\n\n/* .header__menuDropdownItems li:first-of-type.active svg rect,\n.header__menuDropdownItems li:last-of-type.active svg rect,\n.header__menuDropdownItems li:first-of-type.active svg path,\n.header__menuDropdownItems li:last-of-type.active svg path,\n.header__menuDropdownItems li:first-of-type:hover svg rect,\n.header__menuDropdownItems li:last-of-type:hover svg rect,\n.header__menuDropdownItems li:first-of-type:hover svg path,\n.header__menuDropdownItems li:last-of-type:hover svg path {\n} */\n\n.header__menuDropdownItemAuth {\n  font-weight: bold;\n  font-size: 0.8rem;\n  padding: 0.5em 1em;\n  width: 100%;\n  display: block;\n  color: var(--clr-gray600) !important;\n  text-align: right;\n}\n\n.header__menuDropdownItemAuth.logout {\n  color: var(--clr-primary) !important;\n}\n\n.header__menu.text-white .header__mobileIcon path {\n  fill: var(--clr-light);\n}\n\n.header__menu.text-white svg path,\n.header__profile.text-white svg path {\n  stroke: var(--clr-light);\n}\n\n@media (min-width: 768px) {\n  .header__logo span {\n    font-size: 1.25rem;\n  }\n}\n\n@media (min-width: 992px) {\n  header {\n    max-height: 7.5rem;\n  }\n\n  .header__items {\n    flex-direction: row;\n    position: unset;\n    clip-path: none;\n    height: 100%;\n    width: 100%;\n    /* gap: 1rem; */\n    background: transparent;\n    -webkit-clip-path-: none;\n    -moz-clip-path-: none;\n    color: var(--clr-dark);\n  }\n\n  .header__checked {\n    display: none;\n  }\n\n  .header__item {\n    font-size: 0.75rem;\n    display: flex;\n    margin: 0 0.5rem;\n  }\n\n  .header__item.active,\n  .header__item.active a {\n    color: var(--clr-primary);\n  }\n  .header__mobileIcon {\n    display: none;\n  }\n\n  .header__logo img {\n    max-width: 3.5rem;\n  }\n\n  .header__logo span {\n    display: inline-block;\n    white-space: nowrap;\n  }\n\n  .header__item.text-white {\n    color: var(--clr-light);\n  }\n\n  .header__item.text-white a,\n  .header__item a {\n    color: var(--clr-light);\n  }\n\n  .header__menu.text-white svg path,\n  .header__profile.text-white svg path {\n    stroke: var(--clr-light);\n  }\n\n  .header__item a {\n    color: var(--clr-dark);\n  }\n\n  .header__item.active,\n  .header__item.active a {\n    color: var(--clr-primary);\n  }\n}\n\n/* @media (min-width: 992px) {\n  .header__logo span {\n    display: inline-block;\n    white-space: nowrap;\n  }\n} */\n\n@media (min-width: 1100px) {\n  .header__items {\n    margin-right: -1rem;\n  }\n\n  .header__item {\n    font-size: 0.85rem;\n    margin: 0 0.6rem;\n  }\n}\n\n@media (min-width: 1300px) {\n  .header__logo span {\n    display: inline-block;\n    white-space: nowrap;\n    font-size: 1.5rem;\n  }\n\n  /* .header__items {\n    gap: 1.5rem;\n  } */\n\n  .header__logo img {\n    max-width: 4rem;\n  }\n  .header__item {\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 1800px) {\n  header.full-width {\n    padding-left: 20%;\n    padding-right: 20%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
